module.exports = __webpack_public_path__ + "static/img/头像3.c76d643.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/头像3.png
// module id = sRhw
// module chunks = 1